import { FC, Children } from 'react';
import style from './index.module.css';

export const Grid: FC<{
  children: React.ReactNode
}> = ({ children }) => {

  const arrayChildren = Children.toArray(children);

  return (
    <div className={style.root}>
      {arrayChildren.map((child, index) => (
        <div key={index} className={style.item}>
          {child}
        </div>
      ))}
    </div>
  )
}